import { Box, Typography } from '@mui/material';

const RotatingCardFront = ({
    color = 'info',
    image,
    icon,
    title,
    description,
    bgPosition = null,
}) => {
    return (
        <Box
            //className='frontCard'
            display='flex'
            justifyContent='center'
            alignContent='center'
            borderRadius={3}
            boxShadow={color}
            width='100%'
            position='relative'
            background='transparent'
            //variant='contained'
            //opacity={1}
            zIndex={2}
            sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: 'cover',
                backfaceVisibility: 'hidden',
                ...(bgPosition !== null && { backgroundPosition: bgPosition }),
            }}
        >
            <Box py={12} px={3} textAlign='center' lineHeight={1}>
                {icon && (
                    <Typography variant='h2' color='white' my={2}>
                        {icon}
                    </Typography>
                )}
                <Typography variant='h3' color='white' gutterBottom>
                    {title}
                </Typography>
                <Typography variant='body2' color='white' opacity={0.8}>
                    {description}
                </Typography>
            </Box>
        </Box>
    );
};

export default RotatingCardFront;
